export var MARKUP_MARKER_TYPE = 0;
export var ATOM_MARKER_TYPE = 1;